interface WorldWithMachineSVGProps {
  color: string;
  style: React.CSSProperties;
}

const WorldWithMachineSVG = ({ color, style }: WorldWithMachineSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="51"
    viewBox="0 0 52 51"
    fill="none"
  >
    <g clipPath="url(#clip0_955_12373)">
      <path
        d="M16.2862 33.821H25.9098"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6953 33.821H11.7004"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.14374 33.821H7.14884"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.2862 44.8892H25.9098"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6953 44.8892H11.7004"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.14374 44.8892H7.14884"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5921 50.4808H0.509735V39.4127H32.549V50.4808H15.521"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.509735 39.4126V28.3446H32.549V39.4126"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.7908 11.4306C35.9173 11.4306 41.4417 10.0622 45.32 7.87158"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.549 33.9684C37.5607 34.3085 42.0306 35.5752 45.3174 37.4337"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.549 44.1233C42.9799 42.7468 51.0416 33.6578 51.0416 22.6514C51.0416 10.6942 41.5284 1 29.7882 1C18.0479 1 8.53995 10.6942 8.53995 22.6514C8.53995 24.6223 8.79763 26.529 9.28144 28.3447"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.549 43.6225C37.2951 41.215 40.8027 32.7393 40.8027 22.654C40.8027 10.6969 35.8752 1.00269 29.7908 1.00269"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.0416 22.6512H8.53995"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.7908 1V28.3447"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1627 28.3447C18.9129 26.529 18.7788 24.6223 18.7788 22.6514C18.7788 10.6942 23.709 1 29.7908 1"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.7881 11.4306C23.6616 11.4306 18.1399 10.0622 14.2615 7.87158"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_955_12373">
        <rect width="52" height="51" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default WorldWithMachineSVG;
